export default __webpack_public_path__ + "static/media/boltorange-250-min.30a23da4.png";